/* ============================================================
   COA DATA — one current-batch certificate record per product.
   Batch/date/purity values are placeholder test data in the
   house format, pending upload of signed lab-issued originals.
   Deterministic "random" (seeded) so values stay stable per handle.
   ============================================================ */
window.COA_DATA = (() => {
  function seedRand(str){
    let h=0; for(let i=0;i<str.length;i++){h=(h*31+str.charCodeAt(i))>>>0;}
    return ()=>{h=(h*1103515245+12345)>>>0; return (h>>>8)/0xFFFFFF;};
  }
  function pad(n){return String(n).padStart(2,'0');}
  const MONTHS=['Jan','Feb','Mar','Apr','May','Jun','Jul'];

  function record(p){
    const rnd=seedRand(p.handle);
    const strength=(p.strengths&&p.strengths[0])||'—';
    const prefix=p.title.replace(/[^A-Za-z]/g,'').slice(0,2).toUpperCase()||'PD';
    const batch=`${prefix}-26${pad(1+Math.floor(rnd()*6))}-${String.fromCharCode(65+Math.floor(rnd()*5))}`;
    const purity=(98.6+rnd()*1.3).toFixed(2);
    const largestImp=(0.15+rnd()*0.5).toFixed(2);
    const totalRelated=(largestImp*1+0.2+rnd()*0.3).toFixed(2);
    const water=(3+rnd()*5).toFixed(1);
    const endotoxin=(0.1+rnd()*0.4).toFixed(2);
    const bioburden=Math.round(2+rnd()*8);
    const rt=(14+rnd()*8).toFixed(2);
    const day=1+Math.floor(rnd()*27);
    const month=MONTHS[Math.floor(rnd()*7)];
    const testDate=`${day} ${month} 2026`;
    const isBlend=/blend|&/i.test(p.title);
    const isTablet=/tabs|water/i.test(p.title);
    return {
      handle:p.handle, title:p.title, category:p.category, strength, batch,
      quantity:strength, purity, largestImp, totalRelated, water, endotoxin, bioburden,
      rt, testDate, docId:`COA-${batch}`,
      appearance:isTablet?'White powder / tablet, uniform':'White to off-white lyophilized powder',
      method: isBlend ? 'RP-HPLC (C18), dual-component' : 'RP-HPLC (C18)',
      sequenceNote: isBlend ? 'Multi-component blend — see individual peptide monographs' : 'On file — available on request',
    };
  }

  const all=(window.PRODUCTS||[]).map(record);
  const byHandle={};
  all.forEach(r=>byHandle[r.handle]=r);
  return {all, byHandle};
})();
